export default "__VITE_ASSET__FXEkbNeO__"